import React, { useEffect, useState } from "react";

import banner1 from "./../../../../assets/ac-services/banner1.png";
import banner2 from "./../../../../assets/ac-services/banner2.png";

const pricingItems = [
  { title: "AC Service", price: "₹499" },
  { title: "Installation - Window AC", price: "₹899" },
  { title: "Installation - Split AC", price: "₹1,399" },
  { title: "Uninstall - Window AC", price: "₹599" },
  { title: "Uninstall - Split AC", price: "₹799" },
  { title: "AC Visit (Inspection Only)", price: "₹299" },
  { title: "Gas Refill & Check", price: "₹2,749", badge: "45 Days Warranty" },
  { title: "AMC - Comprehensive", price: "₹3,499 / Year" },
  { title: "AMC - Non-Comprehensive", price: "₹1,999 / Year" },
];

const trustPoints = [
  "Certified & experienced AC technicians",
  "On-time doorstep service",
  "Transparent pricing - no hidden charges",
  "Warranty on gas refill services",
];

const heroPhone = "9318397171";
const secondaryPhone = "9625049297";

const styles = {
  section: {
    marginTop: "2rem",
    marginBottom: "2rem",
  },
  introCard: {
    background: "linear-gradient(135deg, #e8f2ff 0%, #f8fbff 100%)",
    border: "1px solid #d7e6fb",
    borderRadius: "24px",
    padding: "1.5rem",
    marginBottom: "1rem",
  },
  introEyebrow: {
    color: "#1565c0",
    fontSize: "0.8rem",
    fontWeight: 700,
    letterSpacing: "0.08em",
    textTransform: "uppercase",
    marginBottom: "0.5rem",
  },
  introTitle: {
    fontSize: "clamp(1.5rem, 3vw, 2.35rem)",
    fontWeight: 700,
    color: "#0f2747",
    marginBottom: "0.65rem",
  },
  introText: {
    color: "#45607e",
    fontSize: "1rem",
    lineHeight: 1.6,
    marginBottom: 0,
  },
  bannerButton: {
    display: "block",
    width: "100%",
    padding: 0,
    border: 0,
    borderRadius: "20px",
    overflow: "hidden",
    boxShadow: "0 18px 45px rgba(21, 101, 192, 0.14)",
    background: "#ffffff",
    cursor: "pointer",
    transition: "transform 180ms ease, box-shadow 180ms ease",
  },
  bannerImage: {
    width: "100%",
    display: "block",
    objectFit: "cover",
  },
  bannerHint: {
    position: "absolute",
    right: "1rem",
    bottom: "1rem",
    background: "rgba(15, 39, 71, 0.82)",
    color: "#ffffff",
    borderRadius: "999px",
    padding: "0.5rem 0.9rem",
    fontSize: "0.8rem",
    fontWeight: 600,
    letterSpacing: "0.02em",
  },
  modalBackdrop: {
    position: "fixed",
    inset: 0,
    background: "rgba(3, 14, 31, 0.8)",
    zIndex: 10000,
    padding: "1rem",
  },
  modalShell: {
    width: "100%",
    height: "100%",
    background: "#f4f8fd",
    borderRadius: "24px",
    overflowY: "auto",
    overflowX: "hidden",
    boxShadow: "0 30px 80px rgba(0, 0, 0, 0.35)",
  },
  closeButton: {
    position: "sticky",
    top: "1rem",
    marginLeft: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "46px",
    height: "46px",
    borderRadius: "999px",
    border: "1px solid rgba(255,255,255,0.28)",
    background: "rgba(255,255,255,0.14)",
    color: "#ffffff",
    fontSize: "1.6rem",
    lineHeight: 1,
    cursor: "pointer",
    backdropFilter: "blur(8px)",
  },
  hero: {
    background: "#1565c0",
    color: "#ffffff",
    padding: "1.5rem 0 2rem",
  },
  heroPanel: {
    background: "linear-gradient(135deg, rgba(255,255,255,0.08) 0%, rgba(255,255,255,0.02) 100%)",
    border: "1px solid rgba(255,255,255,0.1)",
    borderRadius: "28px",
    padding: "1.5rem",
  },
  heroTitle: {
    fontSize: "clamp(1.8rem, 3.8vw, 3.6rem)",
    fontWeight: 800,
    lineHeight: 1.12,
    marginBottom: "0.85rem",
  },
  heroSubtitle: {
    fontSize: "1.05rem",
    lineHeight: 1.7,
    color: "rgba(255,255,255,0.88)",
    marginBottom: "1.25rem",
  },
  buttonRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.9rem",
    marginBottom: "1.25rem",
  },
  primaryButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "52px",
    padding: "0.85rem 1.35rem",
    borderRadius: "999px",
    background: "#ffca28",
    color: "#0e2c55",
    fontWeight: 700,
    textDecoration: "none",
    boxShadow: "0 12px 28px rgba(255, 202, 40, 0.28)",
  },
  secondaryButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "52px",
    padding: "0.85rem 1.35rem",
    borderRadius: "999px",
    border: "1px solid rgba(255,255,255,0.38)",
    color: "#ffffff",
    fontWeight: 700,
    textDecoration: "none",
    background: "rgba(255,255,255,0.08)",
  },
  phoneWrap: {
    display: "flex",
    flexWrap: "wrap",
    gap: "0.75rem",
    alignItems: "center",
  },
  phoneLink: {
    color: "#ffffff",
    fontWeight: 800,
    fontSize: "clamp(1.1rem, 2.3vw, 1.55rem)",
    textDecoration: "none",
    letterSpacing: "0.01em",
  },
  contentSection: {
    padding: "2rem 0",
  },
  sectionTitle: {
    color: "#0f2747",
    fontSize: "clamp(1.4rem, 2vw, 2rem)",
    fontWeight: 800,
    marginBottom: "1rem",
  },
  pricingCard: {
    background: "#ffffff",
    border: "1px solid #dbe8f7",
    borderRadius: "20px",
    padding: "1.1rem",
    height: "100%",
    boxShadow: "0 12px 26px rgba(15, 39, 71, 0.06)",
  },
  pricingLabel: {
    color: "#294566",
    fontWeight: 700,
    fontSize: "1rem",
    marginBottom: "0.55rem",
  },
  pricingValue: {
    color: "#1565c0",
    fontWeight: 800,
    fontSize: "1.2rem",
    marginBottom: 0,
  },
  badge: {
    display: "inline-flex",
    alignItems: "center",
    marginTop: "0.7rem",
    padding: "0.4rem 0.75rem",
    borderRadius: "999px",
    background: "#e8f5e9",
    color: "#1b5e20",
    fontSize: "0.78rem",
    fontWeight: 700,
  },
  notice: {
    marginTop: "1.5rem",
    padding: "1rem 1.1rem",
    background: "#fff8d6",
    border: "1px solid #f3d366",
    borderRadius: "16px",
    color: "#705200",
    fontWeight: 700,
  },
  trustCard: {
    background: "#ffffff",
    border: "1px solid #dbe8f7",
    borderRadius: "24px",
    padding: "1.5rem",
    boxShadow: "0 12px 26px rgba(15, 39, 71, 0.06)",
  },
  trustItem: {
    display: "flex",
    alignItems: "flex-start",
    gap: "0.85rem",
    marginBottom: "1rem",
    color: "#294566",
    fontSize: "1rem",
    lineHeight: 1.55,
  },
  trustTick: {
    minWidth: "34px",
    height: "34px",
    borderRadius: "999px",
    background: "#e3f2fd",
    color: "#1565c0",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 900,
  },
  bottomCard: {
    background: "linear-gradient(135deg, #0f4ca4 0%, #1565c0 100%)",
    borderRadius: "28px",
    padding: "1.6rem",
    color: "#ffffff",
    textAlign: "center",
    boxShadow: "0 20px 46px rgba(21, 101, 192, 0.24)",
  },
  bottomButton: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "56px",
    width: "100%",
    maxWidth: "440px",
    padding: "0.9rem 1.4rem",
    borderRadius: "999px",
    background: "#ffffff",
    color: "#0f4ca4",
    textDecoration: "none",
    fontWeight: 800,
    fontSize: "1rem",
    marginBottom: "1rem",
  },
  bottomPhoneList: {
    display: "flex",
    flexDirection: "column",
    gap: "0.35rem",
  },
};

function ACServicesBanner() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const previousOverflow = document.body.style.overflow;

    if (isOpen) {
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  return (
    <React.Fragment>
      <section style={styles.section} aria-label="Voorent AC Services">
        <div style={styles.introCard}>
          <div style={styles.introEyebrow}>Voorent AC Services</div>
          <h2 style={styles.introTitle}>Cooling support that converts attention into service bookings</h2>
        </div>

        <div className="row">
          {[{ image: banner1, alt: "Voorent AC Services banner one" }, { image: banner2, alt: "Voorent AC Services banner two" }].map(
            (banner, index) => (
              <div key={index} className="col-12 col-lg-6 mb-4">
                <div style={{ position: "relative" }}>
                  <button
                    type="button"
                    style={styles.bannerButton}
                    onClick={openModal}
                    aria-label="Open Voorent AC Services details"
                  >
                    <img style={styles.bannerImage} src={banner.image} alt={banner.alt} />
                  </button>
                  <span style={styles.bannerHint}>Tap to view services</span>
                </div>
              </div>
            ),
          )}
        </div>
      </section>

      {isOpen && (
        <div
          style={styles.modalBackdrop}
          onClick={closeModal}
          role="presentation"
        >
          <div
            style={styles.modalShell}
            onClick={(event) => event.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-label="Voorent AC Services details"
          >
            <section style={styles.hero}>
              <div className="container py-2">
                <button type="button" style={styles.closeButton} onClick={closeModal} aria-label="Close AC services overlay">
                  ×
                </button>
                <div className="row align-items-center">
                  <div className="col-12">
                    <div style={styles.heroPanel}>
                      <h1 style={styles.heroTitle}>AC Services at Your Doorstep - Fast, Reliable &amp; Affordable</h1>
                      <p style={styles.heroSubtitle}>
                        Expert AC repair, installation, servicing &amp; AMC plans with transparent pricing.
                      </p>

                      <div style={styles.buttonRow}>
                        <a href={`tel:${heroPhone}`} style={styles.primaryButton}>
                          Book a Service
                        </a>
                        <a href={`tel:${secondaryPhone}`} style={styles.secondaryButton}>
                          Call Now
                        </a>
                      </div>

                      <div style={styles.phoneWrap}>
                        <a href={`tel:${heroPhone}`} style={styles.phoneLink}>
                          {heroPhone}
                        </a>
                        <span style={{ color: "rgba(255,255,255,0.55)" }}>|</span>
                        <a href={`tel:${secondaryPhone}`} style={styles.phoneLink}>
                          {secondaryPhone}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section style={styles.contentSection}>
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <h2 style={styles.sectionTitle}>Service Pricing</h2>
                  </div>
                </div>
                <div className="row">
                  {pricingItems.map((item) => (
                    <div key={item.title} className="col-12 col-sm-6 col-xl-4 mb-4">
                      <div style={styles.pricingCard}>
                        <div style={styles.pricingLabel}>{item.title}</div>
                        <p style={styles.pricingValue}>{item.price}</p>
                        {item.badge && <span style={styles.badge}>{item.badge}</span>}
                      </div>
                    </div>
                  ))}
                </div>

                <div style={styles.notice}>Note: 18% GST charges applicable apart from the above prices.</div>
              </div>
            </section>

            <section style={{ ...styles.contentSection, paddingTop: 0 }}>
              <div className="container">
                <div className="row">
                  <div className="col-12 col-lg-10">
                    <div style={styles.trustCard}>
                      <h2 style={styles.sectionTitle}>Why Customers Choose Voorent AC Services</h2>
                      {trustPoints.map((point) => (
                        <div key={point} style={styles.trustItem}>
                          <span style={styles.trustTick}>✓</span>
                          <span>{point}</span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section style={{ ...styles.contentSection, paddingTop: 0, paddingBottom: "2.5rem" }}>
              <div className="container">
                <div style={styles.bottomCard}>
                  <a href={`tel:${heroPhone}`} style={styles.bottomButton}>
                    Book Your Service Today with Voorent
                  </a>
                  <div style={styles.bottomPhoneList}>
                    <a href={`tel:${heroPhone}`} style={{ ...styles.phoneLink, fontSize: "1.15rem" }}>
                      {heroPhone}
                    </a>
                    <a href={`tel:${secondaryPhone}`} style={{ ...styles.phoneLink, fontSize: "1.15rem" }}>
                      {secondaryPhone}
                    </a>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

export default ACServicesBanner;
